export const lang = {
  pageSubTitle: {
    ja: '洗練されたアプリの創造で、より良いウェブの世界を目指す。',
    en: 'I craft beautiful apps and strive for a better web.',
  },
  contactBtn: {
    ja: 'Contact',
    en: 'Contact',
  },
  chapterProjects: {
    ja: 'プロジェクト',
    en: 'Projects',
  },
  descriptionLetsPlay: {
    ja: "Let's Playは、 Vision Proのために手作りされた一連のアプリです。チェスや囲碁といった時代を超えたゲームの楽しみ方を再定義し、テーブルの上や手の中でゲームが生き生きと楽しめるようにします。",
    en: "Let's Play is a series of apps hand-crafted for  Vision Pro. It redefines the way you engage with the timeless games of Chess and Go, bringing them to life in on your table and in your hands.",
  },
  descriptionColorfulCasting: {
    ja: 'カラキャスは世界中の個性を繋ぐエンタメアプリです。スキマ時間に、SNS感覚でお仕事の検索やお仕事に必要なコミュニケーションなどがアプリひとつで完結！',
    en: 'Colorful Casting is an entertainment app that connects unique individuals from around the world. Castings can be organised and influencer marketing can be coordinated on for brands and promotions. Includes public talent profiles, messaging, payment platform, search engine and more.',
  },
  descriptionPepicons: {
    ja: 'Pepiconsは、総数500個+の完全オリジナルアイコンパッケージです。このアイコンセットには、POP!、Print、Pencilバージョンの3種類のバリエーションがあり、どちらもレトロな雰囲気を基調としたアイコンセットになっています。ウェブサイトのライブプレビューでは、このパックが提供するすべてのアイコンを試用することができます。',
    en: 'Pepicons is a grand total of 500+ hand-crafted icons — and counting! This completely original icon set is made in three retro variants: Pop!, Print and Pencil. A live preview on the website allows you to play around with all the variations the icon pack has to offer.',
  },
  descriptionCM: {
    ja: 'CineMatchでは、映画のウォッチリストを作成して友達と共有することができます。このアプリのユーザーインターフェースは、美しく見やすさを追求したものになっています。',
    en: 'With the help of CineMatch a user can create film watchlists and share them with friends. This neat app has a clean user interface that organizes the user’s lists beautifully and with simplicity.',
  },
  chapterTeamEfforts: {
    ja: '協力プロジェクト',
    en: 'Team Efforts',
  },
  descriptionUBI: {
    ja: 'ベーシックインカムでどれだけ利益を得ているのか疑問に思ったことはありませんか？ UBI Calculatorでは、さまざまなUBIプランで得た収益を正確に把握できるようにするオリジナルプラグインです。',
    en: 'Ever wonder how you might benefit through a Universal Basic Income The UBI Calculator is an ingenius plugin that allows a user to calculate their exact earnings with different UBI plans.',
  },
  descriptionPL: {
    ja: 'PeerLearningは、学生達が協力して互いに学び合うためのオンライン教育ソフトです。教育分野の助成金によって資金提供を受けているこのソフトは、現在米国の学校で使用されています。',
    en: 'PeerLearning is an online education software bringing students together to collaborate and learn from one another. Funded by education-focused grants, currently used in schools in the United States.',
  },
  chapterFrameworks: {
    ja: 'フレームワーク',
    en: 'Frameworks',
  },
  descriptionPlanetar: {
    ja: 'この軽快なVueフレームワークは、リアルタイムに反映されるスタイルガイドを自動生成します。開発者とデザイナーの相互の創造と開発をより強力にするコンポーネントエクスプローラーが利用できます。',
    en: 'This nimble Vue framework creates an auto-generated, living style guide. The style guide comes complete with an interactive component explorer that both developers and designers will love.',
  },
  descriptionMagnetar: {
    ja: 'アプリのデータ、柔軟にアクセス可能に。\n\nこのフレームワークに依存しない同期ソリューションは、任意のデータベースまたはAPIに連携し、データが簡単に取得可能になるうえ、ローカルで整理・編集すると自動的にサーバーへ同期されます。さらに、サーバー同期前にUIが先に更新されるオプティミスティックUI機能が組み込まれています。',
    en: 'Your data, where you want.\n\nThis framework-agnostic syncing solution can automatically connect to any DB or API and keep your data organised for you in a local data store. Plus, it’s got optimistic-UI built right in.',
  },
  descriptionBlitzar: {
    ja: 'BlitzarはVueJSのフォームとデータテーブルを簡単なJSONのようなシンタックスで生成可能にする。',
    en: 'Blitzar gives you the power to generate Vue Forms and Data-tables fast with a simple JSON-like syntax.',
  },
  descriptionPlanetarShort: {
    ja: 'リアルタイムに反映されるスタイルガイドを自動生成する軽快なVueフレームワークです。',
    en: 'This nimble Vue framework creates an auto-generated, living style guide.',
  },
  descriptionMagnetarShort: {
    ja: 'フレームワークに依存しない同期ソリューションであり、任意のデータベースまたはAPIに連携し、データが簡単に取得・整理・編集可能になります。',
    en: 'A framework-agnostic syncing solution that keeps your data where you need it.',
  },
  descriptionBlitzarShort: {
    ja: 'VueJSのフォームとデータテーブルを簡単なJSONのようなシンタックスで生成可能にする。',
    en: 'Generate Vue Forms and Data-tables fast with a simple JSON-like syntax.',
  },
  howWeDesign: {
    ja: 'How I design',
    en: 'How I design',
  },
  howWeDesignSubtext: {
    ja: 'ユーザーの意図を明確にとらえたデザインで、ユーザーの理想を実現します。',
    en: 'With clarity and focus, I enable the user to engage with purpose.',
  },
  howWeCode: {
    ja: 'How I code',
    en: 'How I code',
  },
  howWeCodeSubtext: {
    ja: 'シンプルでモダン、そして適応性の高いコードでデザインの美しさを表現します。',
    en: 'Matching the beauty of the design, my code is modern, concise, and adaptive.',
  },
  chapterAboutUs: {
    ja: 'About',
    en: 'About',
  },
  nameLuca: {
    ja: 'バン・ルカ',
    en: 'Luca Ban',
  },
  bioLuca: {
    ja: '誕生以来、テクノロジー愛好家です。コードを書くことと詩を書くことは同じことだと思っています。不可能なことは存在しない — 才能は自分に教えるスキルと信じています。',
    en: 'Has been a technology enthusiast since birth. He thinks of writing code as nothing less than poetry. Believes everything is possible — talent is a skill you teach yourself.',
  },
  nameTadaki: {
    ja: '松下忠己',
    en: 'Tadaki Matsushita',
  },
  bioTadaki: {
    ja: '自動化大好きな独学のプログラマー。日本中の企業ビジョンをプログラミングで支援してきました。Webマーケティングも得意としています。',
    en: 'Self taught coder. He has helped companies all over Japan turn their vision into code. Excels at web marketing; and currently loves automation.',
  },
}
